import { inject, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';

@Pipe({ name: 'sanitizeHtml', standalone: true })
export class SanitizeHtmlPipe implements PipeTransform {
  sanitizer = inject(DomSanitizer);

  transform(value: string): SafeHtml {
    if (value) {
      var find = 'Upload/editor-image';
      var re = new RegExp(find, 'g');

      value = value.replace(re, environment.apiDomain + 'upload/editor-image');
    }

    return this.sanitizer.bypassSecurityTrustHtml(value);
  }
}
